module.exports = __webpack_public_path__ + "cf17981d87b16bd37591d5d5113504a3.svg";